import { render } from "./MahallaFundReports.vue?vue&type=template&id=1477b577&scoped=true"
import script from "./MahallaFundReports.vue?vue&type=script&lang=js"
export * from "./MahallaFundReports.vue?vue&type=script&lang=js"

import "./MahallaFundReports.vue?vue&type=style&index=0&id=1477b577&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1477b577"]])

export default __exports__